module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/ja/3-a84a866978f1567793868535a6e2cee1.jpg";